import React from 'react'
import classNames from 'classnames'

import './VerticalGroup.scss'
import { ThemeSpacing } from '../../../types/theme'

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  bottom?: boolean
  spread?: boolean
  className?: string
  verticalCenter?: boolean
  full?: boolean
  half?: boolean
  center?: boolean
  reverse?: boolean
  wide?: boolean
  flexAuto?: boolean
  spaceBetweenElements?: ThemeSpacing
}

const VerticalGroup = React.forwardRef<HTMLDivElement, Props>(({ children, bottom, spread, verticalCenter, full, half, wide, center, reverse, spaceBetweenElements, className, flexAuto, ...rest }, ref) => {
  const spaceBetweenElementsClass = spaceBetweenElements ? `space-between-${spaceBetweenElements}` : null
  return (
    <div ref={ref}
      className={classNames('vertical-group', {
        bottom,
        spread,
        full,
        half,
        'align-center': center,
        center: verticalCenter,
        reverse,
        wide,
        flexAuto,
      }, spaceBetweenElementsClass, className)}
      {...rest}
    >
      {children}
    </div>
  )
})

export default VerticalGroup
